

import __layout_0 from '/opt/build/repo/src/layouts/default.vue'
export const layouts = {
'404': () => import('/opt/build/repo/src/layouts/404.vue'),
'default': __layout_0,
'home': () => import('/opt/build/repo/src/layouts/home.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      component: layouts[route.meta?.layout || 'default'],
      children: [ {...route, path: ''} ],
    }
  })
}
